import { useUser } from './UserContext';
import { Navigate } from 'react-router-dom';
import LoadingScreen from '../components/shared/LoadingScreen';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useUser();

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;